const opts = {
  filterable: false,
  sortable: false
};
export default {
  id: 'sale.voidedBy',
  name: 'sale.voidedBy',
  displayName: 'Sale Voided By',
  valueType: 'string',
  objectType: 'sale',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    return obj;
  }
};